<template>
<v-container class="pt-0 pb-0">
    <v-row>
        <v-col cols="4" class="pt-0">
            <v-combobox
                v-model="type_customer"
                :items="item_type_customers"
                label="Tipo de cliente"
                hide-details
                clearable
                @change="handleSelectTypeCustomer"
                @click:clear="handleClearSelectTypeCustomer"
                solo
                dense>
            </v-combobox>
        </v-col>
        <v-col cols="4" class="pt-0">
            <v-autocomplete
                v-model="value_customer"
                :items="debts"
                dense
                solo
                clearable 
                clear-icon="far fa-times-circle"               
                label="Clientes"
                persistent-hint
                :item-text="customText"
                item-value="id"
                hide-details
                @change="handleSelecteCustomer"
                :filter="customFilter"
            >
                <template v-slot:item="data">
                    <v-list-item-content>
                        <v-list-item-title v-if="data.item.type_document === 'DNI' ">{{ data.item.name }} {{ data.item.surname }}</v-list-item-title>
                        <v-list-item-title v-else>{{ data.item.name }}</v-list-item-title>
                        <v-list-item-subtitle>{{ data.item.type_document }}: {{ data.item.document }}</v-list-item-subtitle>
                    </v-list-item-content>
                </template>
            </v-autocomplete>
        </v-col>
        <v-col cols="2" class="pt-0 pb-0">
            <v-btn-toggle
                v-model="type_view"
                mandatory
                dense
                @change="handleChangeTypeView"
                >
                <v-btn>
                    <v-icon size="18">fas fa-border-all</v-icon>
                </v-btn>
                <v-btn>
                    <v-icon size="18">fas fa-bars</v-icon>
                </v-btn>                        
            </v-btn-toggle>
        </v-col>
    </v-row>
</v-container> 
</template>
<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
    name: 'FilterDebt',
    data() {
        return {
            type_view: 0,
            type_customer: null,
            item_type_customers: [
                {
                    text: 'JURÍDICO',
                    value: 'RUC'
                },
                {
                    text: 'NATURAL',
                    value: 'DNI'
                }
            ],
            value_customer: '',
        }
    },
    computed: {
        ...mapState('debts', [
            'debts'
        ])
    },
    methods: {
        ...mapActions('debts', [
            'getDebts',
            'runSetTypeView'
        ]),
        handleSelectTypeCustomer(){
            let filter_type_customer = null
            if(this.type_customer){
                filter_type_customer = this.type_customer.value
            }
            this.searchDebts(filter_type_customer)
        },
        handleClearSelectTypeCustomer(){
            let filter_type_customer = null
            this.searchDebts()
        },
        searchDebts(type_customer = null, customer_id = null){
            let request = {
                params: {
                    customer_id: customer_id,
                    type_document: type_customer
                }
            }
            this.getDebts(request)
        },
        customText(item){
            let text = item.name
            if (item.type_document === 'DNI') {
                text = item.name + ' ' + item.surname
            }
            return text
        },
        handleSelecteCustomer(value){            
            let customer_id = null            
            if(value !== undefined && value !== null){
                customer_id = value
            }
            this.searchDebts(null, customer_id)
        },
        customFilter(item, queryText, itemText) {
            let textName = '';

            if (item.name) {
                textName = item.name.toLowerCase();
            }
                
            let textDocument = '';
            if (item.document) {
                textDocument = item.document.toLowerCase();             
            }
            
            let searchText = queryText.toLowerCase()


            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        },
        handleChangeTypeView(val){
            this.runSetTypeView(val)
        }
    }
}
</script>

<style scoped>

</style>